import './ApostropheProvider.css';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import theme from '../../theme';
import { ToastProvider } from '../../tools/toast';
const ApostropheProvider = ({ children, }) => {
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(ToastProvider, null, children)));
};
export default ApostropheProvider;
//# sourceMappingURL=ApostropheProvider.js.map